import AgreementsList from './AgreementsList';

export default AgreementsList;
